import { SYNC_ORDER_REQUEST, SYNC_ORDER_SUCCESS, SYNC_ORDER_FAILURE, SYNC_ORDER_REST, } from "../../actions";
const initialState = {
    syncOrders: [],
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SYNC_ORDER_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, syncOrders: null });
        case SYNC_ORDER_SUCCESS:
            return Object.assign(Object.assign({}, state), { syncOrders: action.payload, isLoading: false, error: null });
        case SYNC_ORDER_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case SYNC_ORDER_REST:
            return Object.assign(Object.assign({}, state), { syncOrders: null, isLoading: true, error: null });
        default:
            return state;
    }
};
export default reducer;
